var HoverShape = require('../hoverShape/hoverShape'),
    ShapeUtils = require('../../../models/shapeUtils'),
    ShapeTransformedModel = require('../../../models/shapeTransformModel/shapeTransformModel');


/**
 * Now printing a 'not ready indicator' -- there will just be nothing.
 * TODO:
 * - have it's own event on the noteModel for all of them for consult group change now*
 */

var HoverTextStamp = HoverShape.extend({

    initialize: function( options ) {

        HoverShape.prototype.initialize.apply( this, arguments );

        // ( there is no shape yet created with current design so we need to create an instance )
        this.shapeTransformModel = new ShapeTransformedModel( ).initializePageValues( this.channel.request('getPage'), this.originalScale );

        this.listenTo( this.channel, 'hoverShape:scale', this.updateScale ); // TODO: better org: scale from mixin is the scale fn name from base ( get rid of mixin ??? -- need to outline )

        var uiModel = this.note.uiModel;

        this.listenTo( uiModel, 'change:selectedStamp', this.update );
        this.listenTo( uiModel, 'change:inputsValid',   this.update );

        this.listenTo( uiModel, 'change:generatedText', this.update );
        this.listenTo( uiModel, 'change:fontSize',      this.update );
        this.listenTo( uiModel, 'change:font',          this.update );

        // could be less efficent, but probably won't occur-- eg break up into change size or note like shapeView ( need to outline )
        this.listenTo( uiModel, 'change:textColor',     this.update );
        this.listenTo( uiModel, 'change:textOpacity',   this.update );
        // if ready ... can also, change the text on set text ...

        /* Cache pgCenterRotatedAtScaleOf1 for Move Transforms */

        var pgRotation = this.shapeTransformModel.getPageModel().getRotation();
        var pgCenter = this.shapeTransformModel.getPageModel().getCenter();

        // Store on model if have other instances
        this.pgCenterRotatedAtScaleOf1 = ShapeUtils.getPtsWithoutTransformApplied( [ pgCenter  ] , 1.0, pgRotation, pgCenter )[0];

        // Could also encapsulate this on model
        this.shapeTransformModel.setRotation( pgRotation % 360 * -1 );

        uiModel.set( 'rotationAtZeroPageRotation', this.shapeTransformModel.getRotation() ); // ( for passing to the shapeView )

    },

    /* ( text set in update attributes ) */
    createEl: function( ) {

        var el = this.paper.text( this.ox, this.oy, '' ).attr({
            'text-anchor': 'start', // ( horizontal )
            stroke: 'none' // stroke width may be set via other Raphael attrs changes
        });
        this._updateAttributes( this.note.uiModel, el );

        // Transform only takes page model into account now;
        // this.el doesn't yet exist -- so use calc'd transform to call directly on the element with that value
        // not this.el which is done on this object
        this.shapeTransformModel.getPageModel().updateTransform( el.transform.bind(el) );

        return el;

    },


    /**
     * inputsValid: for now not printing a warning just show the preview
     */
    _getTextToPrint: function( inputsValid )  {
        //return inputsValid ? this.note.uiModel.getGeneratedText(): this.note.uiModel.getGeneratedText();
        return this.note.uiModel.getGeneratedText();

    },

    /**
     * x, y are client coordinates
     * rPt: the point at original page rotation of 0, scale 1
     */
    onMouseMove: function( x, y ) {

        var shapeTransModel = this.shapeTransformModel,
            shapePgTransModel = shapeTransModel.getPageModel();

        // Could encapsulate on model ...
        var rPt = ShapeUtils.getPtsWithoutTransformApplied( [{ x: x , y: y }] , shapePgTransModel.getScale(), shapePgTransModel.getRotation(),  this.pgCenterRotatedAtScaleOf1  )[0];
        shapeTransModel.setDx( rPt.x );
        shapeTransModel.setDy( rPt.y );

        this.transform();

    },

    
    update: function() {
        this._updateAttributes();
        this.transform( );

    },

    /* Also updates this.obox */
    _updateAttributes: function ( noteUiModel, el ) {

        noteUiModel = noteUiModel || this.note.uiModel;
        el = el || this.el;

        el.attr({
            text: this._getTextToPrint( noteUiModel.getInputsValid() ),
            'font-size': noteUiModel.getFontSize(),
            'font-family': noteUiModel.getFont(),
            fill: noteUiModel.getColorToApply(),
            opacity: noteUiModel.getTextOpacity()
        });

        this.shapeTransformModel.setOBox( el.getBBox(1) );

    },

    updateScale: function( scale ) {

        var shPgTransformModel = this.shapeTransformModel.getPageModel();
        shPgTransformModel.setScale( scale ); // could the update the transform there
        shPgTransformModel.updateTransform(); // could have set scale update the transform
        this.transform();

    },

    transform: function( t ) {

        var trans = '';

        if ( t ) {
            trans += t;
        }

        var shapeTransModel = this.shapeTransformModel;
        var r = shapeTransModel.getRotation();

        trans += shapeTransModel.getPageModel().getTransform();

        trans += 't' + shapeTransModel.getDx()  + ',' + shapeTransModel.getDy(); // move transform

        if ( r !== 0 ) {
            trans += 'r' + r  + ',' + this.ox + ',' +  this.oy;
        }

        // Y-Char Offset
        trans += 't0,' + shapeTransModel.getOBox().height / 2 ; // could also be on model ...

        this.el.transform( trans );


    },

    /**
     * OR: called on render -- this shape has opacity and use that
     * I don't think we'd want this to have 0 opacity so maybe don't reflect the hovershape ?
     * could have flag to bypass this in the base class -- so it is not overruled
     */
    getHoverOpacity: function() {

        return this.note.uiModel.getTextOpacity();
    },
    /* OR: called on clone -- this shape has opacity and use that */
    getPlacedOpacity: function() {

        return this.note.uiModel.getTextOpacity();
    },

    deriveShapeFromClone: function() {

        var el = HoverShape.prototype.deriveShapeFromClone.apply( this, arguments );

        el.attr({
            transform: '',
            x: this.shapeTransformModel.getDx(),
            y: this.shapeTransformModel.getDy()
        });

        return el;

    }


});



module.exports = HoverTextStamp;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/textStamp/hoverTextStamp.js
 ** module id = 386
 ** module chunks = 0
 **/